import React, { useContext, useEffect, useState } from "react";
import IDaily_Route from "../../../models/IDaily_Route";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import INewDaily_Route from "../../../models/INewDaily_Route";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwButton from "../../shared/OwButton/OwButton";
import { useFormik } from "formik";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import { Moment } from "moment-timezone";
import IProcessDailyRouteDTO from "../../../models/DTO/IProcessDailyRouteDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnProcessDailyRouteDTO from "../../../models/DTO/IOnProcessDailyRouteDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    dailyRoute?: IDaily_Route;
    cancelFn: (refresh?: boolean) => void;
};

export const DailyRouteSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [dailyRoute, setDailyRoute] = useState<IDaily_Route | INewDaily_Route | undefined>(props.dailyRoute);
    const [isDisabled, setIsDisabled] = useState(true);

    const cancel = () => {
        props.cancelFn();
    };

    const processDailyRoute = (values: { route_date: string; route_id: number | undefined }) => {
        if (dailyRoute) {
            const payload: IProcessDailyRouteDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                dailyRoutes: [
                    {
                        dailyRoute: {
                            ...dailyRoute,
                            route_date: values.route_date,
                        },
                    },
                ],
            };

            socket.emit(EndpointsEnum.RoutesProcessDailyRoute, payload);
        }
    };

    const onProcessDailyRoute = (data: IOnProcessDailyRouteDTO) => {
        const notification: INotification = {
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
            message: "successfully_processed_daily_route",
        };

        uiContext.notifyFn(null, notification);

        props.cancelFn(true);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.RoutesOnProcessDailyRoute, fn: onProcessDailyRoute }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const formik = useFormik({
        initialValues: {
            route_id: dailyRoute?.route_id || undefined,
            route_date: dailyRoute?.route_date || "",
        },
        onSubmit: (values) => {
            // props.getTransportOptions(values);
            processDailyRoute(values);
        },
        validate: (values) => {
            const errors: any = {};

            if (!values.route_date) {
                errors.route_date = "Required";
            }

            if (!values.route_id) {
                errors.route_id = "Required";
            }

            setIsDisabled(Object.keys(errors).length > 0);

            return errors;
        },
    });

    return (
        <div className={"DailyRouteSidebar p-2"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-truck-front"} title={"daily_route"} />
                    <hr />
                </div>
            </div>

            <div className="row">
                <form onSubmit={formik.handleSubmit}>
                    <div className={"d-flex flex-column mb-4"}>
                        <div>
                            <OwLabel title={"route_date"} isBold={true} />
                        </div>
                        <div className={""}>
                            <OwDateInput
                                fn={(date: Moment) => {
                                    console.log("Route Date: ", date.format("YYYY-MM-DD"));
                                    const e = {
                                        target: {
                                            value: date.format("YYYY-MM-DD"),
                                            name: "route_date",
                                        },
                                    };

                                    formik.handleChange(e);
                                }}
                                selectedDate={formik.values.route_date}
                            />
                        </div>
                    </div>

                    <div>
                        <OwButton type={"submit"} title={"save"} disableOnActive={true} disabled={isDisabled} />
                    </div>
                </form>
            </div>
        </div>
    );
};
